import { ActionReducer } from '@ngrx/store';
import * as paramsAction from '../url-params.actions';
import { UrlParams } from '../model/url-params.model';

/**
 * Reducer handles url params.
 */
export const urlParams: ActionReducer<UrlParams> = (state: UrlParams = null, {type, payload}: paramsAction.Actions) => {
    switch (type) {
        case paramsAction.PARAMS_CHANGED:
            return payload;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/reducers/url-params.reducer.ts